export default __webpack_public_path__ + "static/media/ikyo.f7aed8ef.webp";